"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(string, props) {
    if (props === void 0) { props = {}; }
    return string && string.replace(/\{{(\w+)\}}/g, function (match, expr) { return props[expr] || ''; });
}
exports.default = default_1;
//# sourceMappingURL=interpolate.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-sdk/dist/src/utils/interpolate.js
// module id = 58
// module chunks = 0 1